import { RentalObjectSearchService } from '../../../common/service/data/property-base-search.service';
import { SidebarService } from '../../../core/service/sidebar.service';
import { BankTransactionImportService } from '../../service/data/bank-transaction-import.service';
import { BankTransactionImport } from '../../model/bank-transaction-import';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { BankTransactionStatusCommand } from '../../command/bankTransactionStatusCommand';
import { BankImportTransactionCommandHandlerResolver } from '../../service/command/bank-import-transaction-command-handler-resolver';
import { dateTimeString } from '../../../core/helper/date-time';
import { LanguageService } from '../../../core/service/language.service';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';

@Component({
    selector: 'app-unhandled-bank-transaction-form',
    templateUrl: './unhandled-bank-transaction-form.component.html',
    styleUrls: ['./unhandled-bank-transaction-form.component.scss'],
    providers: [
        DeleteFormCommandHandler,
        { provide: DataService, useExisting: BankTransactionImportService },
        BankImportTransactionCommandHandlerResolver,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnhandledBankTransactionFormComponent extends FormComponentBase<BankTransactionImport, BankTransactionImportService> {
  canManageBankTransactionImports = false;

  constructor(
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _sidebarService: SidebarService,
    activatedRoute: ActivatedRoute,
    dataService: BankTransactionImportService,
    dispatcher: CommandDispatcher,
    commandHandlerResolver: BankImportTransactionCommandHandlerResolver,
    // handlerResolver: FormCommandHandlerResolver,
    messageService: MessageService,
    navigation: NavigationService,
    private languageService: LanguageService,
    accountService: UserAccountService
  ) {
    super(activatedRoute, dataService, messageService, navigation, dispatcher, commandHandlerResolver);

    this.addDeleteMenu = false;
    this.AddSubscription(
      accountService.current.subscribe(account => {
        if (this.canManageBankTransactionImports || !account.hasAccess(ModuleNames.Invoicing, Features.ManageIncorrectPayments)) {
          return;
        }
        this.canManageBankTransactionImports = true;
        if (this.canManageBankTransactionImports) {
          this.addMenuItemDefinition('BANK_IMPORT_TRANSACTIONS.IGNORE', BankTransactionStatusCommand.setStatusIngored);
          this.addMenuItemDefinition('BANK_IMPORT_TRANSACTIONS.UNDO_IGNORED', BankTransactionStatusCommand.setStatusUnhandled);
          this.addMenuItemDefinition('BANK_IMPORT_TRANSACTIONS.BOOK_AS_INCORRECT_PAYMENT', BankTransactionStatusCommand.setStatusHandled);
        }
      })
    );
  }

  rentalObjectService: RentalObjectSearchService;
  protected createModel(): BankTransactionImport {
    return new BankTransactionImport();
  }

  protected getFormGroup(): FormGroup {
    const group = this._fb.group({
      id: this._fcf.createHidden(this.dataContext.id),
      importedAt: this._fcf.createReadonly(
        'BANK_IMPORT_TRANSACTIONS.IMPORTED_AT',
        dateTimeString(this.dataContext.importedAt)
      ),
      bankAccountNumber: this._fcf.createReadonly('COMPANY.BANK_ACCOUNT.IBAN', this.dataContext.bankAccountNumber),
      amount: this._fcf.createReadonly('BANK_IMPORT_TRANSACTIONS.AMOUNT', this.dataContext.amount),
      companyName: this._fcf.createReadonly('COMMON.COMPANY', this.dataContext.companyName),
      debtorName: this._fcf.createReadonly('BANK_IMPORT_TRANSACTIONS.DEBTORNAME', this.dataContext.debtorName),
      transactionText: this._fcf.createReadonly('BANK_IMPORT_TRANSACTIONS.TRANSACTION_TEXT', this.dataContext.transactionText),
      transactionDate: this._fb.group({}),
      transactionStatusCaption: this._fcf.createReadonly(
        'BANK_IMPORT_TRANSACTIONS.TRANSACTION_STATUS',
      this.languageService.instant(this.dataContext.transactionStatusCaption)
      ),
    });
    return group;
  }

  closeSidebar() {
    this._sidebarService.toggleSidebar(false);
  }

  sidebarSubmitted(): void {
    this.closeSidebar();
  }

  sidebarDeleted(): void {
    this.closeSidebar();
    this.navigation.reloadCurrentRoute();
  }
}
